import * as FromEnrichment from 'reducers/enrichmentWizard/selectors';

export const SLICE = 'enrichment';

export const getEnrichmentFile = state => FromEnrichment.getFile(state[SLICE]);
export const getEnrichmentData = state => FromEnrichment.getData(state[SLICE]);
export const getEnrichmentMappings = state =>
  FromEnrichment.getMappings(state[SLICE]);
export const getEnrichmentSettings = state =>
  FromEnrichment.getSettings(state[SLICE]);
export const getEnrichmentWizardCurrentStep = state =>
  FromEnrichment.getCurrentStep(state[SLICE]);
export const getEnrichmentStatus = state =>
  FromEnrichment.getEnrichmentStatus(state[SLICE]);
export const getEnrichmentListDetails = state =>
  FromEnrichment.getListDetails(state[SLICE]);
export const getEnrichmentSheetName = state =>
  FromEnrichment.getSheetName(state[SLICE]);
export const getEnrichmentType = state => FromEnrichment.getType(state[SLICE]);
export const getDataEnrichmentId = state =>
  FromEnrichment.getDataEnrichmentId(state[SLICE]);
export const getEnrichmentError = state =>
  FromEnrichment.getError(state[SLICE]);
